import React, { useMemo } from 'react';
import { hashCode } from './pixelPersonUtils';

const MATRIX_CHARS = '0123456789アイウエオカキクケコサシスセソツテト0123456789';

/**
 * @param {number} seed
 * @param {number} columnIndex
 * @param {number} rowIndex
 */
function pickMatrixChar(seed, columnIndex, rowIndex) {
  const index =
    Math.abs(hashCode(`${seed}-matrix-${columnIndex}-${rowIndex}`)) %
    MATRIX_CHARS.length;
  return MATRIX_CHARS[index];
}

/**
 * @param {number} seed
 * @param {number} size
 */
export function buildMasterAgentMatrixColumns(seed, size) {
  const chipSize = Math.max(size, 24);
  const columnCount = Math.max(4, Math.min(9, Math.round(chipSize / 7)));
  const rowCount = Math.max(8, Math.round(chipSize / 3.5));

  return Array.from({ length: columnCount }, (_, columnIndex) => {
    const columnSeed = Math.abs(hashCode(`${seed}-matrix-col-${columnIndex}`));
    const chars = Array.from({ length: rowCount }, (_, rowIndex) =>
      pickMatrixChar(seed, columnIndex, rowIndex)
    );

    return {
      id: columnIndex,
      leftPercent: (columnIndex / columnCount) * 100,
      widthPercent: 100 / columnCount,
      durationSec: 1.35 + (columnSeed % 8) * 0.18,
      delaySec: -((columnSeed % 12) * 0.17),
      opacity: 0.28 + (columnSeed % 5) * 0.1,
      chars,
    };
  });
}

/**
 * Matrix-style falling glyph backdrop for Master Agent sprite hover.
 */
export default function MasterAgentMatrixRain({ seed, size = 32 }) {
  const columns = useMemo(
    () => buildMasterAgentMatrixColumns(seed, size),
    [seed, size]
  );

  return (
    <div className="pixel-person-matrix-rain" aria-hidden>
      {columns.map((column) => (
        <span
          key={column.id}
          className="pixel-person-matrix-rain__column"
          style={{
            left: `${column.leftPercent}%`,
            width: `${column.widthPercent}%`,
            opacity: column.opacity,
            animationDuration: `${column.durationSec}s`,
            animationDelay: `${column.delaySec}s`,
          }}
        >
          {column.chars.map((char, rowIndex) => (
            <span
              key={`${column.id}-${rowIndex}`}
              className={
                rowIndex === 0 ? 'pixel-person-matrix-rain__glyph pixel-person-matrix-rain__glyph--lead' : 'pixel-person-matrix-rain__glyph'
              }
            >
              {char}
            </span>
          ))}
        </span>
      ))}
    </div>
  );
}
